import React from 'react';
import Layout from '@/views/layout';

/**
 * default layout
 * @returns {JSX.Element} 返回默认布局组件
 */
export const LayoutIndex = () => <Layout />;
